import { Container } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import {
  deletePastoralActivity,
  getPastoralActivity,
  restorePastoralActivity,
  updatePastoralActivity,
} from "../../../api";
import EditNewsForm from "../../EditNewsForm";

export default function EditPastoralActivity() {
  const location = useLocation();
  const navigate = useNavigate();

  const customSubmitFunction = async (id, title, description, image) => {
    try {
      const result = await updatePastoralActivity(
        id,
        title,
        description,
        image
      );
      if (result) {
        navigate("/pastoral-activity/all");
      }
    } catch (error) {}
  };

  const publishPastoralActivity = async (id) => {
    try {
      await restorePastoralActivity(id);

      navigate("/pastoral-activity/all");
    } catch (error) {}
  };
  const unPublishPastoralActivity = async (id) => {
    try {
      await deletePastoralActivity(id);

      navigate("/pastoral-activity/all");
    } catch (error) {
      throw error;
    }
  };

  const getOnePastoralActivity = async (id) => {
    try {
      const result = await getPastoralActivity(id);
      return result;
    } catch (error) {
      throw error;
    }
  };

  return (
    <>
      <Container>
        <EditNewsForm
          ItemId={location?.state?.parishNewsId}
          breadCrumbLink={"Pastoral Activities"}
          breadCrumbText={"Edit News"}
          goBackLink={"/pastoral-activity/all"}
          customsubmit={customSubmitFunction}
          publishItem={publishPastoralActivity}
          unPublishItem={unPublishPastoralActivity}
          getOneItem={getOnePastoralActivity}
        />
      </Container>
    </>
  );
}
